export default __webpack_public_path__ + "static/media/web-logo.b46cda0d.png";